import { Document } from './document.model';

export interface WorkCompInsurance {
  mailingAddressCity: string;
  mailingAddressState: string;
  mailingAddressStreet: string;
  mailingAddressZip: string;
  name: string;
  phoneNo: string;
  zip?: string;
  claimNo?: string;
  adjudication?: string;
  fax?: string;
  email?: string;
}

export interface ApplicantAttorney {
  name: string;
  firmName: string;
  phone: string;
  fax?: string;
  email?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface DefenseAttorney {
  name: string;
  firmName: string;
  phone: string;
  fax?: string;
  email?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}
export interface Case {
  accountNumber?: string;
  address?: string;
  ambulance?: string;
  caseCategory?: string;
  caseType?: string;
  cellPhone?: string;
  city?: string;
  code?: string;
  createdOn?: string;
  dob?: string;
  doctorSuffix?: string;
  doi?: string;
  driversLicense?: string;
  email?: string;
  emergencyContacts?: string;
  er?: string;
  filestore?: { [key: string]: Document };
  firstName?: string;
  gender?: string;
  homePhone?: string;
  injuries?: string[];
  interpreter?: string;
  interpreterCertNo?: string;
  interpreterRequired?: boolean;
  language?: string;
  lastName?: string;
  maritalStatus?: string;
  medicalTreatment?: string;
  middleInitial?: string;
  name?: string;
  nextAppointment?: string;
  nextAppointmentType?: string;
  orgCode?: string;
  orgName?: string;
  otherDoi?: string;
  otherPhone?: string;
  patientKey: string;
  sendTextMessages?: string;
  ssn?: string;
  state?: string;
  status?: number;
  title?: string;
  treatingDoctor?: string;
  workCompInsurance?: WorkCompInsurance | null;
  age?: number;
  facility?: string;
  zip?: string; // Added zip
  attorney?: ApplicantAttorney; // Added applicantAttorney
  defenseAttorney?: DefenseAttorney; // Added defenseAttorney
  employmentInfo?: EmploymentInfo | null; // Added employmentInfo
  caseFlow?: CaseFlow; // Added actionItems
  healthInsurance?: HealthInsurance; // Added healthInsurance
  doctor?: string;
  dl?: string;
  // accidentDetails?: AccidentDetails;
  ct?: any; // Added ct
  doiEnd?: Date | string; // Added doiEnd
  time?: string; // Added time
  org: any;
}

export interface EmploymentInfo {
  employer?: string;
  occupation?: string;
  employmentStatus?: string;
  jobTitle?: string;
  jobDescription?: string;
  natureOfBusiness?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface CaseFlow {
  actionItems?: ActionItem;
}

export interface ActionItem {
  description: string;
  name: string;
  dueDate?: string;
  completedOn: Date | string;
  sharedWith?: {
    doctor?: boolean;
  };
}

export interface HealthInsurance {
  name?: string;
  policyNo?: string;
  phone?: string;
  fax?: string;
  mailingAddress?: string;
  mailingAddressStreet?: string;
  mailingAddressCity?: string;
  mailingAddressState?: string;
  mailingAddressZip?: string;
}

export enum CaseType {
  WC = 'WC',
  PI = 'PI',
  OTHER = 'OTHER',
}